import React from 'react';
import Box from "@amzn/meridian/box";
import TopMetricsRow from '../../TopMetricsRow/v2/TopMetricsRowContainer';

interface MetricsSectionProps {
  /** True for the RCC Proposed view, false for Operator Override. Forwarded to
   *  the volume card so its label matches the selected plan view. */
  isRccProposedView?: boolean;
}

/**
 * Refactored (V2) metrics section — UTR-REFLEX-1163. Renders the V2 three-card
 * top metrics row from the currently-selected plan's output. Sibling of
 * MetricsSection so V1 is untouched. Layout comes from Meridian (Box), so no
 * custom CSS.
 */
const MetricsSection: React.FC<MetricsSectionProps> = ({ isRccProposedView = true }) => {
  return (
    <Box>
      <TopMetricsRow isRccProposedView={isRccProposedView} />
    </Box>
  );
};

export default MetricsSection;
